'use strict';

/**
 * Finnish business id (Y-tunnus) input handling for the v2 application form.
 *
 * The field always shows the canonical 1234567-8 form: the dash is inserted
 * automatically after the 7th digit, a dash typed by the user is absorbed, and
 * anything sent to the backend goes through normalizeBic(). See bic.test.js.
 */

/** Canonical form when 8 digits are present, otherwise the trimmed input as-is. */
export const normalizeBic = (raw) => {
  const d = (raw || '').replace(/\D/g, '');
  return d.length === 8 ? `${d.slice(0, 7)}-${d.slice(7)}` : (raw || '').trim();
};

/**
 * Value to show after an input event.
 * @param raw   what is now in the input (after the browser applied the keystroke/paste)
 * @param prev  what the field showed before the keystroke
 */
export const maskBic = (raw, prev) => {
  let digits = (raw || '').replace(/\D/g, '');
  // Backspace on the auto-inserted dash: the browser removed only the dash — remove the digit before it too.
  if (prev && prev.endsWith('-') && raw === prev.slice(0, -1)) digits = digits.slice(0, -1);
  digits = digits.slice(0, 8);
  return digits.length >= 7 ? `${digits.slice(0, 7)}-${digits.slice(7)}` : digits;
};

/**
 * Where the caret should be after re-masking, given where it was in the raw value.
 * Counts the digits before the caret and places it after the same digit in the masked
 * value (jumping over the dash once 7 digits are behind the caret).
 */
export const caretAfterMask = (raw, rawCaret, masked) => {
  const digitsBefore = (raw || '').slice(0, rawCaret || 0).replace(/\D/g, '').length;
  const dashPassed = digitsBefore >= 7 && masked.length >= 8 ? 1 : 0;
  return Math.min(masked.length, digitsBefore + dashPassed);
};
